export default class SongDTO {
  // Song data transfer object to send details to server
  wallet_address: string;
  songCoverImg: File;
  songName: string;
  forSale: boolean;
  description: string;
  price: string;
  songFile: File;
  quantity: string;
  // 0 is master copy, 1 is collectible
  type: string;
  launchDate: number;
  fullSongLength: boolean;
  spotifyUrl: string;
  youtubeUrl: string;


  constructor(
    wallet_address: string,
    songCoverImg: File,
    songName: string,
    forSale: boolean,
    description: string,
    price: string,
    songFile: File,
    quantity: string,
    type:string,
    launchDate: number,
    fullSongLength: boolean,
    spotifyUrl: string,
    youtubeUrl: string
  ) {
    this.wallet_address = wallet_address;
    this.songCoverImg = songCoverImg;
    this.songName = songName;
    this.forSale = forSale;
    this.description = description;
    this.price = price;
    this.songFile = songFile;
    this.quantity = quantity;
    this.type = type;
    this.launchDate = launchDate;
    this.fullSongLength = fullSongLength;
    this.spotifyUrl = spotifyUrl;
    this.youtubeUrl = youtubeUrl;
  }
}
